import { neutral } from '../global';
export const brandAltBorder = {
    ctaTertiary: neutral[7],
};
//# sourceMappingURL=brand-alt.js.map
